export default "__VITE_ASSET__B36dyFZ2__"